<div class="main">
    <div class="section">
        <div class="header">
            {{'VIEW_DRIVER.title' | translate}}
            <i class="material-icons" (click)="closeDialog();">clear</i>
        </div>
        <div class="container">
            <div class="content">
                <div class="driver-info">
                    <div class="info">
                        <p>{{'VIEW_DRIVER.driver_name' | translate}}</p>
                        <h3>{{driverData.driverName}}</h3>
                    </div>
                </div>
                <div class="driver-info">
                    <div class="info">
                        <p>{{'VIEW_DRIVER.mobile_number' | translate}}</p>
                        <h3>{{driverData.mobileNumber}}</h3>
                    </div>
                </div>
                <div class="driver-info">
                    <div class="info">
                        <p>{{'VIEW_DRIVER.profile_pic' | translate}}</p>
                        <img src="{{driverData.profilePic}}" height="50px" width="50px">
                    </div>
                </div>
                <div class="driver-info">
                    <div class="info">
                        <p>{{'VIEW_DRIVER.licence_number' | translate}}</p>
                        <h3>{{driverData.licenceNumber}}</h3>
                    </div>
                </div>
                <div class="driver-info">
                    <div class="info">
                        <p>{{'VIEW_DRIVER.expiry_date' | translate}}</p>
                        <h3>{{driverData.expiry_date}}</h3>
                    </div>
                </div>
                <div class="driver-info" [hidden]="!driverData.driver_type">
                    <div class="info">
                        <p>{{'VIEW_DRIVER.driver_type' | translate}}</p>
                        <h3>{{driverData.driver_type}}</h3>
                    </div>
                </div>
                <div class="driver-info" [hidden]="!driverData.driver_address">
                    <div class="info">
                        <p>{{'VIEW_DRIVER.driver_address' | translate}}</p>
                        <h3>{{driverData.driver_address}}</h3>
                    </div>
                </div>
                <div class="driver-info" [hidden]="!driverData.vehicle_no">
                    <div class="info">
                        <p>{{'VIEW_DRIVER.vehicle_number' | translate}}</p>
                        <h3>{{driverData.vehicle_no}}</h3>
                    </div>
                </div>
                <div class="driver-info" [hidden]="!driverData.truck_type">
                    <div class="info">
                        <p>{{'VIEW_DRIVER.truck_type' | translate}}</p>
                        <h3>{{driverData.truck_type}}</h3>
                    </div>
                </div>
                <div class="driver-info">
                    <div class="info">
                        <p>{{'VIEW_DRIVER.smartPhone' | translate}}</p>
                        <h3>{{driverData.smartPhone}}</h3>
                    </div>
                </div>
                <div class="driver-info">
                    <div class="info">
                        <p>{{'VIEW_DRIVER.osversion' | translate}}</p>
                        <h3>{{driverData.os_version}}</h3>
                    </div>
                </div>
                <div class="driver-info">
                    <div class="info">
                        <p>{{'VIEW_DRIVER.mobile_ram' | translate}}</p>
                        <h3>{{driverData.ram}}</h3>
                    </div>
                </div>
                <div class="driver-info">
                    <div class="info">
                        <p>{{'VIEW_DRIVER.mobile_model' | translate}}</p>
                        <h3>{{driverData.model}}</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>